module.exports = __webpack_public_path__ + "img/peseta-sign.51ea6305.svg";